
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { findAndUpdatePhase, resolveActiveMeetingAndPhase } from '../../canvas/workflow/MeetingUtil';
import { SetupPhaseModel } from '../../canvas/workflow/SetupPhaseModel';
import { ToastHub } from '../toast/ToastHub';
import { IncognitoInfo } from './IncognitoInfo';

export const incognitoStart = defineCommand(
    'incognitoStart',
    null,
    cc => {

        const objects = cc.call(ObjectManager);
        const toast = cc.call(ToastHub);

        const [meeting, phase] = resolveActiveMeetingAndPhase(objects);
        if (!meeting || !phase) return;
        if (!!phase.incognito) return;

        const model = SetupPhaseModel.createFromExisting(meeting, phase);
        model.update({ incognito: true });
        findAndUpdatePhase(objects, model);

        toast.invokeAndSend('meeting:incognito', { state: 'enabled' });

    }
);

export const incognitoFinish = defineCommand(
    'incognitoFinish',
    null,
    cc => {

        const objects = cc.call(ObjectManager);
        const toast = cc.call(ToastHub);

        const [meeting, phase] = resolveActiveMeetingAndPhase(objects);
        if (!meeting || !phase) return;
        if (!phase.incognito) return;

        const model = SetupPhaseModel.createFromExisting(meeting, phase);
        model.update({ incognito: false });
        findAndUpdatePhase(objects, model);

        toast.invokeAndSend('meeting:incognito', { state: 'disabled' });
    }
);

export const incognitoToggle = defineCommand(
    'incognitoToggle',
    null,
    cc => {
        const { enabled } = cc.call(EditorSession).get(IncognitoInfo);
        if (!enabled) cc.call(CommandDispatcher)(incognitoStart);
        else cc.call(CommandDispatcher)(incognitoFinish);
    }
);

export const inIncognitoCommands = () => inCommands(
    incognitoToggle,
    incognitoStart,
    incognitoFinish,
);

